import React from "react"

class Content extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
                <div className="section is-main-section">
                    {this.props.children}
                </div>
        )
    }
}

export default Content
